/**
 * @generated SignedSource<<1b2c68d7646456e5f1b8c854b5e7fbf1>>
 * @relayHash 525f5ef0b0197dd7d4dcb03e04d59e99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81bce6e4b6e5aa0fcbe7f466fed399a185f27ae977ea533b3db03479db6a790c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiServiceHubDetailsPageQuery } from './uiServiceHubDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<uiServiceHubDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "81bce6e4b6e5aa0fcbe7f466fed399a185f27ae977ea533b3db03479db6a790c",
    "metadata": {},
    "name": "uiServiceHubDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
